var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "swiper",
      staticClass: "mku-swiper",
      style: _vm.swiperStyle,
      on: {
        mouseenter: function($event) {
          return _vm.handleHoverSwiper("enter")
        },
        mouseleave: function($event) {
          return _vm.handleHoverSwiper("leave")
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "wrap",
          staticClass: "mku-swiper__wrap mku-global-clear",
          style: _vm.wrapStyle
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.arrow !== "never"
        ? [
            _c("transition", { attrs: { name: "mku-swiper-animation-btn" } }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrow === "always" || _vm.isAtSwiper,
                      expression: "arrow === 'always' || isAtSwiper"
                    }
                  ],
                  staticClass: "mku-swiper__btn mku-swiper__btn--left",
                  on: { click: _vm.handlePrev }
                },
                [
                  _vm._t("prev", [
                    _c("i", {
                      staticClass: "mku-icon mku-icon-double-arrow-left"
                    })
                  ])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "mku-swiper-animation-btn" } }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrow === "always" || _vm.isAtSwiper,
                      expression: "arrow === 'always' || isAtSwiper"
                    }
                  ],
                  staticClass: "mku-swiper__btn mku-swiper__btn--right",
                  on: { click: _vm.handleNext }
                },
                [
                  _vm._t("next", [
                    _c("i", {
                      staticClass: "mku-icon mku-icon-double-arrow-right"
                    })
                  ])
                ],
                2
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "mku-swiper__dots" },
        _vm._l(_vm.items, function(item, index) {
          return _c("li", {
            key: index,
            class: _vm.dotsClasss(index),
            on: {
              click: function($event) {
                return _vm.handleDotsClick(index)
              },
              mouseover: function($event) {
                return _vm.handleDotsHover(index)
              }
            }
          })
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }